
<div class="all-read-wrapper">
  <p @click="confirm">すべて既読にする</p>
</div>
